import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'funnelName'
})
export class FunnelNamePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
